import { ArrowDownRight, ArrowUpRight, Minus, Smile } from "lucide-react";

const Delta = ({ now, prev, suffix = "" }) => {
  const diff = now - prev;
  if (diff === 0) return <span className="text-xs text-slate-400 flex items-center gap-0.5"><Minus className="w-3 h-3" /> same as last week</span>;
  const up = diff > 0;
  return <span className={`text-xs flex items-center gap-0.5 ${up ? "text-emerald-600" : "text-slate-500"}`}>{up ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}{up ? "+" : ""}{diff}{suffix} vs last week</span>;
};

export const WeeklySummary = ({ week }) => {
  if (!week) return null;
  const { current: c, previous: p } = week;
  const shift = c.avg_mood_shift;
  const quiet = c.sessions === 0 && c.tutorials_completed === 0;
  return (
    <section className="rounded-3xl bg-slate-900 text-white p-6 sm:p-8 relative overflow-hidden grain" data-testid="weekly-summary">
      <div className="relative">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-300">This week</p>
        <h2 className="font-display text-xl sm:text-2xl font-bold mt-1 leading-snug" data-testid="weekly-headline">
          {quiet ? "A quiet week so far — that's okay." : c.minutes >= 15 ? `${c.minutes} minutes of practice. That adds up.` : `${c.minutes} minute${c.minutes === 1 ? "" : "s"} of practice this week.`}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
          <div><p className="font-display text-3xl font-extrabold" data-testid="weekly-minutes">{c.minutes}</p><p className="text-xs text-slate-300">minutes</p><Delta now={c.minutes} prev={p.minutes} /></div>
          <div><p className="font-display text-3xl font-extrabold" data-testid="weekly-sessions">{c.sessions}</p><p className="text-xs text-slate-300">sessions</p><Delta now={c.sessions} prev={p.sessions} /></div>
          <div><p className="font-display text-3xl font-extrabold" data-testid="weekly-completed">{c.tutorials_completed}</p><p className="text-xs text-slate-300">tutorials finished</p><Delta now={c.tutorials_completed} prev={p.tutorials_completed} /></div>
          <div>
            <p className="font-display text-3xl font-extrabold flex items-center gap-1" data-testid="weekly-mood">{shift == null ? "—" : `${shift > 0 ? "+" : ""}${shift}`}<Smile className="w-5 h-5 text-emerald-400" /></p>
            <p className="text-xs text-slate-300">avg mood shift</p>
            <p className="text-xs text-slate-400">{shift == null ? "answer both check-ins to see this" : `${c.mood_checkins} check-in${c.mood_checkins === 1 ? "" : "s"} · 5-point scale`}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
